import { SyntheticEvent } from "react";
import { Icon, Table } from "semantic-ui-react";

// Styles
import "./styles/BroadcastListTable.scss";

// Utils
import moment from "moment";

// Serializers
import BroadcastPostSerializer from "@/issara-sdk/types/BroadcastPostSerializer_apps_PRX";

type BroadcastApprovalTableProps = {
  // func & callback
  // onSelectBroadcast?: (row: any) => void;
  onOpenDetail: (broadcastPostId?: number) => void;
  onOpenLog: (broadcastPostId?: number) => void;
  // data
  data: BroadcastPostSerializer[];
  icon: any;
  runSequence: any;
  broadcastApprovalTab?: any;
  previews: Record<string, PreviewData>;
  divisionMap: Record<number, any>; // todo ---
};

type PreviewData = {
  text: string;
  media: string | null;
};

const EMPTY_PREVIEW: PreviewData = { text: "", media: null };

const BroadcastApprovalTable = (props: BroadcastApprovalTableProps) => {
  const { data, previews, divisionMap, icon, onOpenDetail, onOpenLog } = props;

  return (
    <div className="table-broadcast-approval">
      <Table striped compact selectable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Submission date</Table.HeaderCell>
            <Table.HeaderCell>ID</Table.HeaderCell>
            <Table.HeaderCell>Post/Details</Table.HeaderCell>
            <Table.HeaderCell>Group Name</Table.HeaderCell>
            <Table.HeaderCell>Broadcast type</Table.HeaderCell>
            <Table.HeaderCell>Approval Status</Table.HeaderCell>
            <Table.HeaderCell style={{ textAlign: "center" }}>Log</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {data.length === 0 ? (
            <Table.Row>
              <Table.Cell
                colSpan={7}
                textAlign="center"
                style={{ padding: "20px", color: "#999", fontSize: "24px" }}
              >
                <img
                  src={icon}
                  alt="broadcast"
                  style={{
                    width: "50px",
                    height: "50px",
                    marginBottom: "-10px",
                    marginRight: "10px",
                  }}
                />
                No broadcast messages found
              </Table.Cell>
            </Table.Row>
          ) : (
            data.map((row) => {
              const preview = previews[row.firebase_id] || EMPTY_PREVIEW;

              return (
                <Table.Row key={row.id} onClick={() => onOpenDetail(row.id)}>
                  <Table.Cell>
                    <div>
                      {moment(row.sent_reviewed_at).format("DD/MM/YYYY \\[HH:mm\\]") ?? "-"}
                    </div>
                    by {row.sent_reviewed_by_name || ""}
                  </Table.Cell>
                  <Table.Cell>
                    {row.broadcast_id}
                    <div
                      style={{
                        fontSize: "0.85em",
                        color: "#e5436e",
                        border: "1px solid #f382a0",
                        borderRadius: "4px",
                        padding: "2px 6px",
                        marginTop: "5px",
                      }}
                    >
                      {divisionMap[row.division]?.name || `Division ID: ${row.division}`}
                    </div>
                  </Table.Cell>
                  <Table.Cell>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      {preview.media && (
                        preview.media.includes("youtube") ? (
                          <iframe
                            width="150"
                            height="80"
                            src={preview.media}
                            frameBorder="0"
                            allowFullScreen
                            title={`YouTube video preview`}
                          />
                        ) : (
                          <div
                            style={{
                              maxWidth: "150px",
                              maxHeight: "80px",
                              overflow: "hidden",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <img
                              src={preview.media}
                              alt="Preview"
                              style={{ width: "100%", height: "100%", objectFit: "contain" }}
                            />
                          </div>
                        )
                      )}
                      <p>{preview.text}</p>
                    </div>
                  </Table.Cell>
                  <Table.Cell>{row.group_name}</Table.Cell>
                  <Table.Cell>
                    <span>
                      {row.broadcast_type === "SCHEDULE" ? "Schedule" : "Sent Instantly"}
                    </span>
                    <div>
                      {row.broadcast_type === "SCHEDULE" &&
                        moment(row.schedule_broadcasted_at).format("DD/MM/YYYY \\[HH:mm\\]")}
                    </div>
                  </Table.Cell>
                  <Table.Cell>
                    <div style={{ color: row.status === "REVIEW_REJECTED" ? "red" : "black" }}>
                      {row.status_custom_label === "Schedule" ? "Approved" : row.status_custom_label}
                    </div>
                    {row.status !== "PENDING_REVIEW" && (
                      <span>{moment(row.reviewed_at).format("DD/MM/YYYY \\[HH:mm\\]")}</span>
                    )}
                  </Table.Cell>
                  <Table.Cell style={{ cursor: "pointer", textAlign: "center" }}>
                    <Icon
                      className="log-icon"
                      name="history"
                      style={{
                        backgroundColor: "#d9d9d9",
                        borderRadius: "4px",
                        padding: "4px",
                        width: "30px",
                        height: "30px",
                        margin: 0,
                      }}
                      onClick={(e: SyntheticEvent) => {
                        e.stopPropagation();
                        onOpenLog(row.id);
                      }}
                    />
                  </Table.Cell>
                </Table.Row>
              );
            })
          )}
        </Table.Body>
      </Table>
    </div>
  );
};

export default BroadcastApprovalTable;
